import type { WorkLocations } from 'shared'
import type { AppWorkLocationCheckboxGroupProps } from '@/components/AppWorkLocationCheckboxGroup'

export function useWorkLocationFields(
  values: { isOnsite: boolean; isOffsite: boolean; isRemote: boolean },
  onChange: (key: 'isOnsite' | 'isOffsite' | 'isRemote', value: boolean) => void,
): Pick<AppWorkLocationCheckboxGroupProps, 'value' | 'onChange'> {
  return {
    value: { onsite: values.isOnsite, offsite: values.isOffsite, remote: values.isRemote },
    onChange: (v: WorkLocations) => {
      if (v.onsite !== values.isOnsite) onChange('isOnsite', v.onsite)
      if (v.offsite !== values.isOffsite) onChange('isOffsite', v.offsite)
      if (v.remote !== values.isRemote) onChange('isRemote', v.remote)
    },
  }
}
